import config from "../../../_config/global";
import {
  IDeleteSingleArgs,
  IGetSingleArgs,
  IPageAndSearchArgs,
  IUpdateSingleArgs,
} from "../../../interfaces";
import { goFetch } from "../../../utilities/goFetch";

interface apiResponse {
  data: Object;
  message: string;
  success: boolean;
}

class Service {
  async getByPage({ search, pageNo }: IPageAndSearchArgs) {
    const roles = (await goFetch(config.endpoints.roles.getByPage)
      .withQueryParameters({
        search: search ?? "",
        pageSize: config.pageSize,
        pageNumber: pageNo || 1,
      })
      .get()) as any;
    const { paginatedResults, totalCount } = roles?.data[0] || {};
    const itemCount = totalCount?.[0]?.count || 0;
    return {
      pageNo: pageNo,
      pageSize: config.pageSize,
      pageCount: Math.ceil(itemCount / config.pageSize),
      data: paginatedResults,
      itemCount,
    };
  }

 async getRoles(active_only: boolean = false) {
    const roles = (await goFetch(config.endpoints.roles.getByPage)     
      .get()) as any;
    let paginatedResults: any[] = roles?.data;

    if(active_only)
      paginatedResults = paginatedResults?.filter(role => role.is_active == true);
    
    return  paginatedResults as any[];
  }

  async getSingle({ key }: IGetSingleArgs) {
    const role = (await goFetch(`${config.endpoints.roles.getSingle}`)
      .withQueryParameters({ id: key })
      .get()) as unknown as apiResponse;
    return role.data;
  }

  async create() {
    return (await goFetch(
      `${config.endpoints.roles.add}`
    ).put()) as unknown as apiResponse;
  }

  async update({ key, ...rest }: IUpdateSingleArgs) {
    await goFetch(`${config.endpoints.roles.update}`)
      .withBody({
        _id: key,
        ...rest,
      })
      .post();
  }

  async delete(key: IDeleteSingleArgs) {
    await goFetch(`${config.endpoints.roles.delete}`)
      .withBody({ _id: key })
      .delete();
  }
}

export default new Service();
